import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { SelectState } from '@vg-constellation/angular-18/select'

const PAGE_SIZE = 10

@Component({
  selector: 'vmf-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() listSize: number
  @Input() paginationLabel: string

  @Output() newPageNumber = new EventEmitter<number>()
  @ViewChild('selectElement') selectElement: ElementRef<HTMLElement>
  @ViewChild('paginationArialLiveRegion')
  paginationArialLiveRegion: ElementRef<HTMLElement>

  public page: number
  public pageSelect: UntypedFormControl = new UntypedFormControl(1)
  public pages: number[]
  public PAGE_SIZE: number

  ngOnInit() {
    this.PAGE_SIZE = PAGE_SIZE
    if (this.listSize > PAGE_SIZE) {
      this.pages = Array.from(
        { length: Math.ceil(this.listSize / PAGE_SIZE) },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_, index) => index + 1,
      )
      this.changePage({ selectedIndex: 0 } as SelectState)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.listSize = changes?.listSize?.currentValue

    if (this.listSize !== undefined) {
      this.pages = Array.from(
        { length: Math.ceil(this.listSize / PAGE_SIZE) },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_, index) => index + 1,
      )
      this.changePage({ selectedIndex: 0 } as SelectState)
    }
  }

  changePage(newPage: SelectState) {
    let selectedIndex = newPage.selectedIndex + 1
    if (
      selectedIndex * PAGE_SIZE < this.listSize + PAGE_SIZE &&
      selectedIndex >= 1
    ) {
      this.page = selectedIndex
      this.pageSelect.setValue(this.page)
      this.newPageNumber.emit(this.page)
      this.announcePageChange()
    }
  }
  announcePageChange() {
    if (this.paginationArialLiveRegion) {
      this.paginationArialLiveRegion.nativeElement.innerText = `${this.paginationLabel} table updated above`
      if (this.paginationArialLiveRegion.nativeElement.innerText !== '') {
        setTimeout(() => {
          this.paginationArialLiveRegion.nativeElement.innerText = ''
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        }, 1000)
      }
    }
  }
}
